import { render, staticRenderFns } from "./wallets.vue?vue&type=template&id=28bdd8f0&"
import script from "./wallets.vue?vue&type=script&lang=js&"
export * from "./wallets.vue?vue&type=script&lang=js&"
import style0 from "./wallets.vue?vue&type=style&index=0&id=28bdd8f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports